import CompanyTypes from "./actionTypes"


// function that called as action
const getListPages = data => ({
  type: CompanyTypes.GET_COMPANY_PAGES,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListPagesSuccess = data => ({
  type: CompanyTypes.GET_COMPANY_PAGES_SUCCESS,
  payload: data,
})

// function that called as action
const getList = data => ({
  type: CompanyTypes.GET_COMPANY_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListSuccess = data => ({
  type: CompanyTypes.GET_COMPANY_LIST_SUCCESS,
  payload: data,
})


// function that called as action
const postData = (data, action) => ({
  type: CompanyTypes.POST_COMPANY,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const postDataSuccess = data => ({
  type: CompanyTypes.POST_COMPANY_SUCCESS,
  payload: data,
})


// function that called as action
const getDetail = (data, action) => ({
  type: CompanyTypes.GET_DETAIL_COMPANY_BY_ID,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const getDetailSuccess = data => ({
  type: CompanyTypes.GET_DETAIL_COMPANY_BY_ID_SUCCESS,
  payload: data,
})

// function that called as action
const putData = (data, action) => ({
  type: CompanyTypes.PUT_COMPANY,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const putDataSuccess = data => ({
  type: CompanyTypes.PUT_COMPANY_SUCCESS,
  payload: data,
})

const CompanyAction = {
  getListPages,
  getListPagesSuccess,

  getList,
  getListSuccess,

  postData,
  postDataSuccess,

  getDetail,
  getDetailSuccess,

  putData,
  putDataSuccess

}

export default CompanyAction





